import { Typography } from '@gogame/components';

export default ({ id }) => {
  return <Typography>{id ? 'Yes' : 'No'}</Typography>;
};
